import * as React from 'react'
// import { ContentfulKeyValue } from '../../../types/graphql-types'
import classes from './tag-unit.module.scss'

export type WidgetTagUnitProps = {
  tag: GatsbyTypes.Maybe<GatsbyTypes.keyValueFragment>
}

const WidgetTagUnit: React.FC<WidgetTagUnitProps> = ({ tag }) => (
  <span className={classes.tagUnit}>
    <span className={classes.tagKey}>{tag?.key}</span>
    <span className={classes.tagValue}>{tag?.value}</span>
  </span>
)

export default WidgetTagUnit
